import React, { useState, useEffect } from 'react';

const API_BASE = 'https://main.victriedemos.com:3017';

// Documents are stored server-side under uploads/proposals/<key>/ where key is the Definite
// ProposalNumber when one exists, or POLICY-<policyId> as a fallback for non-Definite policies.
export const getProposalDocumentsKey = (policy) => {
  if (!policy) return null;
  if (policy.ProposalNumber) return policy.ProposalNumber;
  const policyId = policy.PolicyIdNo || policy.Policy || policy.Id;
  return policyId ? `POLICY-${policyId}` : null;
};

const fileIcon = (fileName) => {
  const ext = (fileName.split('.').pop() || '').toLowerCase();
  if (ext === 'pdf') return 'bi-file-earmark-pdf';
  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) return 'bi-file-earmark-image';
  if (['doc', 'docx'].includes(ext)) return 'bi-file-earmark-word';
  if (['xls', 'xlsx'].includes(ext)) return 'bi-file-earmark-excel';
  return 'bi-file-earmark';
};

const PolicyDocuments = ({ policy }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const key = getProposalDocumentsKey(policy);

  useEffect(() => {
    if (!key) {
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(`${API_BASE}/api/proposals/${encodeURIComponent(key)}/documents`)
      .then(res => res.json())
      .then(data => setFiles(data.success ? data.files : []))
      .catch(err => {
        console.error('Error fetching proposal documents:', err);
        setFiles([]);
      })
      .finally(() => setLoading(false));
  }, [key]);

  if (!key) return null;

  return (
    <div className="detail-section" style={{ marginTop: '20px' }}>
      <h3>📎 Attached Documents</h3>
      {loading ? (
        <p className="no-data">Loading documents...</p>
      ) : files.length === 0 ? (
        <p className="no-data">No documents attached</p>
      ) : (
        <div className="documents-container">
          <div className="documents-grid">
            {files.map((file, index) => (
              <div key={index} className="document-card">
                <div className="document-icon">
                  <i className={`bi ${fileIcon(file.fileName)}`}></i>
                </div>
                <div className="document-info">
                  <p className="document-name">{file.fileName}</p>
                </div>
                <a
                  href={`${API_BASE}${file.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-view-doc"
                  title="Download Document"
                >
                  <i className="bi bi-download"></i> Download
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PolicyDocuments;
